<template>
  <v-card>

  </v-card>

</template>
<script>
  import {
    XAxis
  } from "./options.ts";
  export default XAxis;
</script>